import React from 'react';

export default function DefaultTabSearchInput({ text }) {
  return (
    <div id="fakesearch-container">
      <div id="fakebox">
        <div id="fakebox-search-icon"></div>
        <div id="fakebox-text">{text}</div>
        <button id="fakebox-microphone" title="Search by voice"></button>
      </div>
    </div>
  );
}
